import { DocumentalTypologyResult, DocumentalValidationCode } from '@isyc-react/types';
const docValidationLineArchives = (docLine, statistics) => {
    var _a;
    return (_a = statistics.typologyAndDocuments[docLine.documentTypeId]) !== null && _a !== void 0 ? _a : [];
};
const docValidationLineResult = (docLine, statistics) => {
    var _a;
    return (_a = statistics.typologyResultMap[docLine.documentTypeId]) !== null && _a !== void 0 ? _a : null;
};
// TODO improve splitting logic between completed and pending or both ...
export const docGroupToCompletedAndPending = (doc, relatedId, relatedObjectTypeId, name) => {
    const res = {
        pending: [],
        completed: [],
    };
    doc.forEach(d => {
        if (d.documentalValidationLines.length > 0) {
            if (d.validation === DocumentalValidationCode.ANY) {
                const statistics = d.evaluationResults;
                const uploaded = d.documentalValidationLines.find(line => docValidationLineArchives(line, statistics).length > 0);
                const result = uploaded ? docValidationLineResult(uploaded, statistics) : null;
                const docReqId = uploaded && uploaded.pendingDocumentRequestIdList[0] ? uploaded.pendingDocumentRequestIdList[0] :
                    d.pendingDocumentRequestIdList ? d.pendingDocumentRequestIdList[0] : undefined;
                if (!docReqId && uploaded && result) {
                    res.completed.push({
                        name: d.documentalGroupName + ' - ' + name,
                        docName: d.documentalGroupName,
                        objectName: name,
                        code: d.documentalGroupCode,
                        validation: d.validation,
                        requests: [
                            {
                                tId: uploaded.documentTypeId,
                                tName: uploaded.documentTypeName,
                                tCode: uploaded.documentTypeCode,
                                status: uploaded.status,
                                result,
                                documentsEdm: docValidationLineArchives(uploaded, statistics),
                            },
                        ],
                    });
                }
                else {
                    res.pending.push({
                        name: d.documentalGroupName + ' - ' + name,
                        docName: d.documentalGroupName,
                        objectName: name,
                        code: d.documentalGroupCode,
                        relatedId,
                        relatedObjectTypeId,
                        validation: d.validation,
                        requests: [
                            {
                                tId: 0,
                                tName: d.documentalGroupName,
                                tCode: d.documentalGroupCode,
                                tFormatList: [],
                                docReqId,
                                options: d.documentalValidationLines.map(line => (Object.assign({}, line))),
                            },
                        ],
                    });
                }
            }
            else {
                const pendingReq = [];
                const completedReq = [];
                const statistics = d.evaluationResults;
                d.documentalValidationLines.forEach(dv => {
                    const docReqId = dv.pendingDocumentRequestIdList[0];
                    const documentsEdm = docValidationLineArchives(dv, statistics);
                    const result = docValidationLineResult(dv, statistics);
                    if (docReqId || documentsEdm.length === 0 || (d.validation !== DocumentalValidationCode.NONE && !result)) {
                        pendingReq.push({
                            tId: dv.documentTypeId,
                            tName: dv.documentTypeName,
                            tCode: dv.documentTypeCode,
                            tFormatList: dv.documentTypeFormatList,
                            docReqId,
                            options: [],
                        });
                    }
                    else {
                        completedReq.push({
                            tId: dv.documentTypeId,
                            tName: dv.documentTypeName,
                            tCode: dv.documentTypeCode,
                            status: dv.status,
                            result: result !== null && result !== void 0 ? result : DocumentalTypologyResult.TYPOLOGY_RESULT_NO_INFO,
                            documentsEdm: documentsEdm,
                        });
                    }
                });
                if (pendingReq.length > 0)
                    res.pending.push({
                        name: d.documentalGroupName + ' - ' + name,
                        docName: d.documentalGroupName,
                        objectName: name,
                        code: d.documentalGroupCode,
                        relatedId,
                        validation: d.validation,
                        relatedObjectTypeId,
                        requests: pendingReq,
                    });
                if (completedReq.length > 0)
                    res.completed.push({
                        name: d.documentalGroupName + ' - ' + name,
                        docName: d.documentalGroupName,
                        objectName: name,
                        code: d.documentalGroupCode,
                        validation: d.validation,
                        requests: completedReq,
                    });
            }
        }
    });
    return res;
};
